export default "__VITE_ASSET__Mk4ZkRbm__"